var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.31266 2.14282C2.08345 2.14282 0.285706 3.89655 0.285706 6.07116V13.9278C0.285706 16.1025 2.08345 17.8562 4.31266 17.8562C6.54187 17.8562 8.33962 16.1025 8.33962 13.9278V6.07116C8.33962 3.89655 6.54187 2.14282 4.31266 2.14282ZM6.0385 9.9995H2.58682V6.07116C2.58682 5.15923 3.37783 4.38759 4.31266 4.38759C5.24749 4.38759 6.0385 5.15923 6.0385 6.07116V9.9995ZM11.0722 8.94727C10.9284 8.84204 10.7126 8.84204 10.6048 8.98234C8.9868 11.192 9.16658 14.2435 11.1801 16.2077C13.2295 18.2069 16.3576 18.3823 18.6227 16.7689C18.7666 16.6636 18.7666 16.4883 18.6227 16.348L11.0722 8.94727ZM19.3418 8.28085C17.2924 6.31668 14.1643 6.14131 11.8992 7.71966C11.7553 7.82488 11.7553 8.03533 11.8632 8.17563L19.4497 15.5763C19.5935 15.6816 19.8092 15.6816 19.8812 15.5413C21.5351 13.3316 21.3553 10.2801 19.3418 8.28085Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7143,
    height: 18.5714,
    transform: "translate(0.285706 0.714233)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicine);
export default __webpack_public_path__ + "static/media/medicine.b28e02ff784704c6ba6bf52cb1a6f98f.svg";
export { ForwardRef as ReactComponent };